import _ from 'lodash';

// controls
const DOCUMENT_MAX_SCALE = 3;
export const DOCUMENT_DEFAULT_SCALE = 1.5;
export const DOCUMENT_MIN_SCALE = 0.1;
export const DOCUMENT_SCALE_STEP = 0.1;

const SCALE_5X = 5;
const SCALE_7_5X = 7.5;
const SCALE_10X = 10;
const SCALE_15X = 15;
const SCALE_20X = 20;
const ADDITIONAL_SCALES = [SCALE_5X, SCALE_7_5X, SCALE_10X, SCALE_15X, SCALE_20X];

export const SCALES = _.concat(
  _.range(DOCUMENT_MIN_SCALE, DOCUMENT_MAX_SCALE + DOCUMENT_SCALE_STEP, DOCUMENT_SCALE_STEP).map(
    scale => _.round(scale, 1),
  ),
  ADDITIONAL_SCALES,
);

export const DOCUMENT_ROTATION_STEP = 90;
export const DOCUMENT_MAX_ROTATION = 270;

// ui
export const DOCUMENT_CONTROL_PANEL_HEIGHT = 56;
export const DOCUMENT_MAX_THUMBNAIL_WIDTH = 186;
export const DOCUMENT_THUMBNAIL_BORDER_OFFSET_PX = 8;
export const DOCUMENT_THUMBNAILS_BLOCK_WIDTH_OPEN = 240;
export const DOCUMENT_THUMBNAILS_BLOCK_WIDTH_CLOSED = 120;
export const DOCUMENT_FIELDS_BLOCK_WIDTH = 300;
export const DOCUMENT_VIEW_MIN_WIDTH = 600;
export const DOCUMENTS_LIST_WIDTH = 280;
export const DOCUMENTS_LIST_WIDTH_REDESIGN = 330;
export const DOCUMENTS_PANE_RAIL_WIDTH = 48;
export const DOCUMENTS_TREE_HEADER_HEIGHT = 232;

// placeholder
export const DOCUMENT_REJECTED_PLACEHOLDER = 'Rejected';
export const DOCUMENT_REJECTED_STATUS = 'Rejected';
// Synthetic bucket for documents whose type belongs to no category — without it,
// selectPreviewDocuments silently drops them from the tree.
export const DOCUMENT_UNCATEGORIZED_PLACEHOLDER = 'Uncategorized';

// exception
export const DOCUMENT_PAGE_RENDERING_CANCELLED_EXCEPTION = 'RenderingCancelledException';

// enums
export const DocumentRotationDirection = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const AiDataRecognitionResult = {
  LAYOUT: 'layout',
  MAPPED_AI_MODEL_FIELDS: 'mappedAiModelFields',
  LAYOUT_AI_MODEL_COMBINED: 'layoutAiModelCombined',
  AI_MODEL_MAPPED_AI_MODEL_FIELDS_COMBINED: 'aiModelMappedAiModelFieldsCombined',
  LAYOUT_MAPPED_AI_MODEL_FIELDS_COMBINED: 'layoutMappedAiModelFieldsCombined',
  ALL_LAYERS: 'allLayers',
};

export const DocumentExtractionRequestMode = {
  MANUAL: 'Manual',
  GEN_AI: 'GenAI',
  AUTO: 'Auto',
};

// GET /api/documents/{id} include values for the embedded extraction request.
// ExtractionSessions is a separate opt-in include — without it the request returns
// sessions: [] and a completed-GenAI-awaiting-review document is indistinguishable
// from one that never ran. Every fetch that hydrates documents[id].extractionRequest
// must pass BOTH (the reducer merge is last-write-wins, so a sessions-less response
// would clobber a sessioned one).
export const EXTRACTION_REQUEST_INCLUDES = ['ExtractionRequest', 'ExtractionSessions'];

// Matches the backend `DocumentUploadSource` enum; document metadata carries its numeric value.
export const DocumentUploadSource = {
  LOS: '1',
  TITLE_PORTAL: '2',
  POS: '3',
  TPO_SIGNUP: '4',
};

export const TITLE_PORTAL_SOURCE_LABEL = 'Title Portal';

export const RECIPIENT_COPY_LABEL = 'Borrower copy';

export const RECIPIENT_COPIES_LABEL = 'Borrower copies';

export const OPEN_DOCUMENT_BLOCKED_MESSAGE =
  'Your browser blocked the document window. Allow pop-ups for this site and try again.';

export const OPEN_DOCUMENT_ERROR_MESSAGE =
  'Could not open document. Try again, or contact your lender if the problem continues.';
